module.exports = __webpack_public_path__ + "static/media/manage_departments_click_add_new_supervisor.b161b15d.mov";